module.exports = __webpack_public_path__ + "static/media/promo_1_pic_1.25e85ded.svg";